import * as React from "react"
import Svg, { Circle } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <Circle cx={12} cy={3} r={2.5} stroke="#fff" />
      <Circle cx={12} cy={12} r={2.5} stroke="#fff" />
      <Circle cx={12} cy={21} r={2.5} fill="#fff" stroke="#fff" />
    </Svg>
  )
}

export default SvgComponent
